module.exports = __webpack_public_path__ + "static/media/suggestedAliasMobile.bb2291da.svg";